import { InformationRecord } from "us.collection.debtor/Interfaces";
import { AdditionalInfoDataTypes } from "us.common/constants";
import _ from "lodash";
import dayjs from "dayjs";

/**
 * @function
 * @description get additional info initial form values
 * @param {number} selectedInfoId selected ad ditional information record id
 * @param {Array} informationList additional information list
 * @returns {object} formatted information object
 */
export const getAdditionalInfoInitFormValues = (
  selectedInfoId: number,
  informationList: Array<any>
): {
  informationList: Array<InformationRecord>;
} => {
  try {
    if (Array.isArray(informationList) && selectedInfoId > -1) {
      const { fieldName, value } =
        _.find(informationList, {
          itemId: selectedInfoId,
        }) ?? {};
      return {
        informationList: [{ key: fieldName, value: value }],
      };
    } else {
      return {
        informationList: [{ key: "", value: "" }],
      };
    }
  } catch (error) {
    return {
      informationList: [{ key: "", value: "" }],
    };
  }
};

/**
 * @function
 * @description - To get the matching data type
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const getValueDataType = (
  selectedFieldName: any,
  metaDataList: Array<any>
): string => {
  try {
    const { dataType } = _?.find(metaDataList, {
      label: selectedFieldName,
    });
    return dataType;
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description - To get the matching default value
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const getDefaultValue = (
  selectedFieldName: any,
  metaDataList: Array<any>
): string => {
  try {
    const { defaultValue, dataType } = _?.find(metaDataList, {
      label: selectedFieldName,
    });

    return dataType == AdditionalInfoDataTypes.BOOLEAN && !defaultValue
      ? ""
      : defaultValue;
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description - Convert value to proper format
 * @param currentField - current field data
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const convertValueToProperFormat = (
  currentField: any,
  metaDataList: Array<any>
): string => {
  try {
    const { key, value } = currentField ?? {};
    const { dataType } = _?.find(metaDataList, {
      label: key,
    });

    if (
      dataType == AdditionalInfoDataTypes.BOOLEAN ||
      dataType == AdditionalInfoDataTypes.DECIMAL ||
      dataType == AdditionalInfoDataTypes.INT
    ) {
      return JSON.parse(value);
    } else if (dataType == AdditionalInfoDataTypes.DATE_TIME) {
      return dayjs(value, "DD/MM/YYYY").toISOString();
    } else {
      return value;
    }
  } catch (error) {
    return currentField?.value;
  }
};
